/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
*
* created by jpatel
* To apply random sample model on dataset
*/

import React from 'react';
import Select from './common/Select';
import reactCSS from 'reactcss'
import PlainButton from './common/PlainButton';
import { DropdownIndicator } from '../utils/dropdown-override';
import ToolTip from './common/ToolTip.js';

// import Dyn from '../lib/dynDataSet/dynMiscellany';
// import mediator from '../lib/dynDataSet/mediatorUtil';

class RandomSampleComponent extends React.Component {
    constructor (props) {
        super(props)
        let Dyn = this.props.Dyn,
            lastGenerate = Dyn.dataSet.caseSampler.getUserDataFromLastGenerate();

        this.defaultStats = [ "kControlsMean", "kControlsStDeviation", "kControlsVariance", "kControlsMedian", "kControlsInterQuartRange" ];

        let sampleStatistics = null;
        if (lastGenerate.statsChecked && lastGenerate.statsChecked.length > 0){
            sampleStatistics = lastGenerate.statsChecked[0];
        } else {
            sampleStatistics = this.getInitialStatsChecked();
        }

        this.state = {
            sampleType: lastGenerate.sampleType || 'with-replace',
            sampleName: lastGenerate.sampleName || 'Sample',
            sampleSize: lastGenerate.sampleSize || this.getInitialSampleSize(),
            sampleCount: lastGenerate.sampleCount || 3,
            hasAttribute: this._hasNumericalAttributeOnAxis(),
            sampleStatistics: sampleStatistics,
            selectedView: lastGenerate.selectedView,
            selectedSampleIndex: Dyn.dataSet.caseSampler.getSelectedSampleIndex(),
            invalidSampleSize : false,
            isGenerating : false
        };
        this.onViewChange = this.onViewChange.bind(this);

        // To sync with plotview
        this.subscriptions = [];
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:setRemovedAttribute", (data) => {
            this.removedAttrTimeout = setTimeout(() => {
                this.setState({
                    hasAttribute: this._hasNumericalAttributeOnAxis()
                });
            }, 100);
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:randomSamplesUpdated", (data) => {
            // notification comes when samples have completed generating, or sampling has been canceled.
            // update activeView radio buttons to match Dyn.dataSet.caseSampler.selectedView when changed.
            this.setState({
                selectedView: data.selectedView,
                selectedSampleIndex: data.sampleIndex,
                isGenerating: false // and re-enable Generate button #1505
            });
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:generateRandomSamples", (data) => {
            // sampling has started; disable Generate button until the sampling has completed or been canceled.
            this.setState({
                isGenerating: true // disable Generate button until sampling is complete #1505
            });
        });
    }

    componentWillUnmount = () => {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
        clearTimeout(this.removedAttrTimeout);
    }

    _hasNumericalAttributeOnAxis = function() {
        let Dyn = this.props.Dyn;
        let hasAttribute = false;
        if(Dyn.plotView.xAxis.allAttributes.attributes.length) {
            hasAttribute = Dyn.plotView.xAxis.allAttributes.attributes[0].stats.isNumeric();
        }

        if(!hasAttribute && Dyn.plotView.yAxis.allAttributes.attributes.length) {
            hasAttribute = Dyn.plotView.yAxis.allAttributes.attributes[0].stats.isNumeric();
        }
        return hasAttribute;
    }

    // Callback for input/texarea value changes
    changeHandler = (event) => {
        this.setState({
            sampleSize: this.refs.sampleSize.value,
        },this.checkSampleSizeValidity);
    }

    checkSampleSizeValidity = () => {
        let Dyn = this.props.Dyn;
        this.setState({
            invalidSampleSize : Dyn.dataSet.getPopulationSize() < this.state.sampleSize && this.state.sampleType === 'without-replace' ? true : false
        });
    }

    changeSampleCount = (event) => {
        this.setState({
            sampleCount: this.refs.sampleCount.value,
        });
    }

    changeName = (event) => {
        this.setState({
            sampleName: this.refs.sampleName.value,
        });
    }


    getSampleSizeAsNumber = () => {

        // convert the sample size to a number, default to 0 if non-numeric
        let n = Number( this.state.sampleSize );
        return ( isFinite( n ) && ( n > 0 )) ? n : 0;

    }

    getMaxSampleSize = () => {
        // Size of each sample, a.k.a. how many cases in each sample? see also getMaxSampleCount()
        return 10000; // too slow otherwise
    }

    getMaxSampleCount = ( currentSampleSize ) => {
        // "No. of Samples": what is the maximum number of samples we can generate that have currentSampleSize cases each?
        const maxCount = 1e4; // hard maximum sample count
        const maxSizeTimesCount = 1e6; // but also don't let sample size * sample count get bigger than this
        let combinedMax = ( currentSampleSize > 0 && currentSampleSize <= this.getMaxSampleSize()) ?
                Math.round(maxSizeTimesCount / currentSampleSize ) : maxCount;
        return Math.min( maxCount, combinedMax ) // too slow otherwise
    }

    getInitialSampleSize = () => {
        let Dyn = this.props.Dyn;

        var maxSize = this.getMaxSampleSize(),
            populationSize = Dyn.dataSet.getPopulationSize(),
            standardSize = 100,
            typicalSize = Math.round( (populationSize >= 50 ? 0.1 : 0.25) * populationSize );
        return Math.min( maxSize, Math.min( standardSize, typicalSize ));

    }

    getInitialStatsChecked = () => {
        let Dyn = this.props.Dyn,
            initialStatsChecked = [];

        this.defaultStats.forEach( (statType) => {
            if( Dyn.plotView.plotShaper.hasElement( Dyn.EPlotControl[statType] )) {
                initialStatsChecked.push( statType );
            }
        });
        if (initialStatsChecked.length > 0) {
            return initialStatsChecked[0];
        } else {
            return 'kControlsMean';
        }
    }

    getPopulationNumCases = () => {
        let Dyn = this.props.Dyn;
        return Dyn.dataSet.getPopulationSize();
    }

    getPopulationNumAttributes = () => {
        let Dyn = this.props.Dyn;
        return Dyn.dataSet.getNumAttributes();
    }

    isSampleSizeValid = () => {
        // sample sizes must be positive integers less that max
        let Dyn = this.props.Dyn;
        let n = this.getSampleSizeAsNumber();
        return( Dyn.mathUtil.isInteger( n) &&
                Dyn.mathUtil.isPositive( n ) &&
                ( n <= this.getMaxSampleSize()) &&
                this.isSampleCountValid() &&
                this.state.sampleName );
    }

    isSampleCountValid = () => {
        // sample counts must be positive integers less that max
        let Dyn = this.props.Dyn;
        let n = this.state.sampleCount,
            s = this.getSampleSizeAsNumber();
        return( Dyn.mathUtil.isInteger( n) &&
            Dyn.mathUtil.isPositive( n ) &&
            ( n <= this.getMaxSampleCount( s )));
    }

    isGenerateButtonDisabled = () => {
        return(
            this.state.isGenerating
            || !this.isSampleSizeValid()
            || !this.state.hasAttribute
            || this.state.invalidSampleSize );
    }

    // Callback for close button click (see also handleCancel())
    handleClose = () => {
        this.props.onClose();
        // TODO - Revert back to the case cards - Check for selected attribute
        // var record = { object: "filter", caseCardScrollTop: this.props.caseCardScrollTop };
        // mediator.publish( "card:reinstateCaseCard", record );
        //
    }

    saveAndRemoveSampling() {
        // Save panel settings before closing
        let Dyn = this.props.Dyn;
        Dyn.dataSet.caseSampler.setUserDataFromLastGenerate( this.getGenerateSettings());

        // Remove the sample filter
        this.props.onApplyRandomSample({ sampleSize: 0 });
    }

    // Callback for cancel button click (see also handleClose())
    handleCancel = () => {
        // close the panel
        this.handleClose();
    }

    // Get the Generate settings for generate/save/restore
    getGenerateSettings = () => {
        var statsChecked = this.state.sampleStatistics
        var data = {
            sampleType: this.refs.sampleType.props.value.value,
            sampleName: this.refs.sampleName.value,
            sampleSize: this.getSampleSizeAsNumber(),
            sampleCount: this.refs.sampleCount.value,
            statsChecked: this.defaultStats.filter(function(e) {return e == statsChecked }),
            statsUnchecked: this.defaultStats.filter(function(e) {return e != statsChecked }),
            selectedView: this.state.selectedView
        };
        // this.state.sampleStatistics = data.statsChecked;
        return data;
    }

    // Callback for Generate button click, to generate a new random sample
    handleGenerate = () => {
        !this.state.invalidSampleSize && this.props.onApplyRandomSample( this.getGenerateSettings() );
    }

    componentDidMount = () => {
        // Focus the panel
        this.refs.randomSamplePanel.focus();
    }

    // To move cursor to the end
    moveCaretAtEnd = ( e ) => {

        var temp_value = e.target.value;
        e.target.value = '';
        e.target.value = temp_value;

    }

    // To listen the keypress on the component
    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }

    getLoc = (str, args) => {
        let Dyn = this.props.Dyn;

        return Dyn.loc( str, args );

    }

    // Handle sample type selection change
    onSampleTypeChange = (obj) => {
        this.setState({
            sampleType: obj.value
        },this.checkSampleSizeValidity);
    }

    // Handle change to Sample Statistics radio button (Mean, St.Dev,...)
    onSampleStatisticsChange = (obj) => {
        // this.refs.stats.getCheckedValues()
        this.setState({ // fixes issue #712
            sampleStatistics: obj.target.value
        });
    }

    // Handle change to View Population, Sample, Distribution radio button
    onViewChange = (event) => {
        var mediator = this.props.Dyn.mediator;
        switch( event.target.value ){
            case "viewDistribution":
                mediator.publish("records:viewDistribution", {});
                break;
            case "viewPopulation":
                mediator.publish("records:viewPopulation", {});
                break;
            default: // re-select last sample, similar to viewOneSample()
                mediator.publish( "records:viewSample", {});
        }
    }

    onNextPrevSample = (direction, event) => {
        // respond to next sample or previous sample button press
        if( event ){
            event.stopPropagation();
        }
        let Dyn = this.props.Dyn,
            sampleIndex = this.state.selectedSampleIndex;
        Dyn.assert( sampleIndex === Dyn.dataSet.caseSampler.getSelectedSampleIndex(), "sampleIndex state not up to date" );
        // view the given sample.
        //      Also switches to viewing samples if viewing distribution or population.
        //      Request is ignored if out of range (0..# samples), or not in sampling mode
        if( direction === 'next' ){
            ++sampleIndex;
        } else {
            Dyn.assert( direction==='prev');
            --sampleIndex;
        }
        Dyn.mediator.publish( "records:viewSample", {sampleIndex: Number( sampleIndex )});
    };

    render = () => {

        let Dyn = this.props.Dyn;
        var options = [
            { value: "with-replace", label: this.getLoc("With Replacement")},
            { value: "without-replace", label: this.getLoc("Without Replacement")}
        ];
        var hasSample = this.props.Dyn.dataSet.caseSampler.hasSamples();
        const styles = reactCSS({
            'default': {
                invalidInput: {
                    border: "1px solid #e9322d",
                    boxShadow: "0 0 6px #f8b9b7"
                },
                populationColor: {
                    cursor: 'pointer',
                    background: `${ Dyn.plotUtil.kCaseColor }`,
                },
                sampleColor: {
                    cursor: 'pointer',
                    background: `${ Dyn.plotUtil.kCaseInSampleColor }`,
                },
                distributionColor: {
                    cursor: 'pointer',
                    background: `${ Dyn.plotUtil.kCaseInDistributionColor }`,
                },

            },
        });

        return (
            <div className="tde-fill" ref="randomSamplePanel" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
                <div className="tde-sliding-panel-header tde-divider-bottom">
                    <div><span
                        className="tde-ml-2 tde-h6 tde-font-weight-bold"
                        role="heading"
                        aria-level="1">{ this.getLoc('SAMPLING CARD') }</span></div>
                    <PlainButton className="tde-mx-2 tde-close-attr-settings" ref="closeButton" title="Close" aria-label={this.getLoc('Close Sampling Card')} onClick={this.handleClose}><i className="tde-i tde-i-remove"></i></PlainButton>
                </div>
                <div className="tde-sliding-panel-body tde-random-sampling-body tde-card-content-bg-color tde-pt-2">
                    <form className="tde-form">
                        <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                        <div className="tde-row">
                                <p className="tde-mt-2 tde-mb-0 tde-font-weight-bold tde-cases-count">{ `${this.getLoc('Population')}: ${this.getPopulationNumCases()} ${this.getLoc('cases')}`}</p>
                        </div>
                        { !this.state.hasAttribute && <div className="tde-row">
                                <div className="tde-error-wrapper tde-mt-3 tde-mb-0 tde-err-msg-text-color">
                                    {/* <i className="tde-i tde-i-exclamation tde-mr-2"></i> */}
                                    <span className="tde-font-weight-regular">{this.getLoc('Place a numerical attribute on the X-Axis or Y-Axis')}</span>
                                </div>
                            </div>
                        }

                        <div className="tde-row tde-mt-3">
                            <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">{ this.getLoc('Type') }<ToolTip tip={this.getLoc('Choose sampling with or without replacement')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></div>
                            <Select
                                id='tde-sampling-type-select'
                                Dyn={this.props.Dyn}
                                ref="sampleType"
                                name="sampleType"
                                className="tde-input tde-select-input tde-input-select"
                                onChange={this.onSampleTypeChange}
                                isClearable={false}
                                aria-label={this.getLoc('Choose sampling with or without replacement')}
                                value={options.find(obj => obj.value === this.state.sampleType)}
                                options={options}
                                // openMenuOnFocus
                                isSearchable={false}
                                tabSelectsValue={false}
                                components={{
                                    Option: ({ data, innerProps, children,innerRef,isSelected,isFocused }) => (
                                        <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} title={data.title} {...innerProps} ref={innerRef}>
                                            <div className="tde-s1">{children}</div>
                                        </div>
                                    ),
                                    DropdownIndicator
                                }}
                            />
                        </div>


                        <div className="tde-row tde-mt-3">
                            <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">{ this.getLoc('Name') }<ToolTip tip={this.getLoc('Input a name for sample(s)')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></div>
                            <input aria-label={this.getLoc('Input a name for sample(s)')}  className="tde-input tde-input-text" type="text" defaultValue={this.state.sampleName} ref="sampleName" name="sampleName"
                                onFocus={this.moveCaretAtEnd} onChange={this.changeName} required={true} style={(!this.state.sampleName ? styles.invalidInput : null)}/>
                        </div>


                        <div className={"tde-d-flex" + (this.props.reduceCaseCardWidth ? " tde-mt-2 tde-flex-direction-col" : " tde-mt-3")}>
                            <div className="tde-row tde-flex-1">
                                <div className="tde-label tde-s1-size tde-attr-name tde-mb-1 tde-font-weight-bold">{this.getLoc('Sample Size')}<ToolTip tip={this.getLoc('Input number of cases in sample(s)')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></div>
                                <input aria-label={this.getLoc('Input number of cases in sample(s)')} className={"tde-input tde-input-text" + (this.props.reduceCaseCardWidth ? " tde-col-6" : " tde-sample-input")} type="text" value={this.state.sampleSize} ref="sampleSize" name="sampleSize"
                                    required={true} style={(!this.state.sampleSize || this.state.invalidSampleSize ? styles.invalidInput : null)}
                                    onChange={this.changeHandler} onFocus={this.moveCaretAtEnd} />
                            </div>

                            <div className={"tde-row tde-flex-1" + (this.props.reduceCaseCardWidth ? " tde-mt-2" : "")}>
                                <div className="tde-label tde-s1-size tde-attr-name tde-mb-1 tde-font-weight-bold">{this.getLoc('No. of Samples')}<ToolTip tip={this.getLoc('Input number of samples that will be drawn in one cycle')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></div>
                                <input aria-label={this.getLoc('Input number of samples that will be drawn in one cycle')} className={"tde-input tde-input-text" + (this.props.reduceCaseCardWidth ? " tde-col-6" : "")} type="text" defaultValue={this.state.sampleCount} ref="sampleCount" name="sampleCount"
                                    required={true} style={(!this.state.sampleCount ? styles.invalidInput : null)} onChange={this.changeSampleCount}
                                    onFocus={this.moveCaretAtEnd} />
                            </div>
                        </div>
                        {this.state.invalidSampleSize && <div className="tde-row">
                                <div className="tde-error-wrapper tde-mt-3 tde-mb-0">
                                    <span className="tde-s1 tde-font-weight-regular">When sampling without replacement, the maximum sample size is the population size.</span>
                                </div>
                            </div>
                        }
                        </div>


                        <div className="tde-row tde-mt-4 tde-pt-4 tde-divider-top">
                            <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                                <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name tde-pb-1">
                                    { this.getLoc('Sample Statistics') }<ToolTip tip={this.getLoc('Choose a Sample Statistic')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip>
                                </div>
                                {/*
                                <div className="tde-checkbox-section">
                                    <CheckboxGroup
                                        name="stats"
                                        ref="stats"
                                        value={this.state.sampleStatistics}
                                        onChange={this.onSampleStatisticsChange}>
                                        <ul style={{listStyle: "none", margin: 0, padding: 0}}>
                                            <li><label><input type="checkbox" value="kControlsMean" className="tde-ml-0"/><span>Mean ( x&#x0304; )</span></label></li>
                                            <li><label><input type="checkbox" value="kControlsStDeviation" className="tde-ml-0"/><span>Standard Deviation  ( s )</span></label></li>
                                            <li><label><input type="checkbox" value="kControlsVariance" className="tde-ml-0"/><span>Variance ( s&#x00B2; )</span></label></li>
                                            <li><label><input type="checkbox" value="kControlsMedian" className="tde-ml-0"/><span>Median</span></label></li>
                                            <li><label><input type="checkbox" value="kControlsInterQuartRange" className="tde-ml-0"/><span>Interquartile Range</span></label></li>
                                        </ul>
                                    </CheckboxGroup>
                                </div>
                                */}
                                <div className="tde-checkbox-section" value={this.state.sampleStatistics} /*onChange={this.onSampleStatisticsChange}*/>
                                    <ul style={{listStyle: "none", margin: 0, padding: 0}}>
                                        <li><label><input type="radio" value="kControlsMean" checked={this.state.sampleStatistics==='kControlsMean'} onChange={this.onSampleStatisticsChange}
                                                        name="stats" className="tde-ml-0"/><span>{ this.getLoc("Mean") } (x&#x0304;)</span></label></li>
                                        <li><label><input type="radio" value="kControlsStDeviation" checked={this.state.sampleStatistics==='kControlsStDeviation'} onChange={this.onSampleStatisticsChange}
                                                        name="stats" className="tde-ml-0"/><span>{ this.getLoc("Standard Deviation") }  (s)</span></label></li>
                                        <li><label><input type="radio" value="kControlsVariance" checked={this.state.sampleStatistics==='kControlsVariance'} onChange={this.onSampleStatisticsChange}
                                                        name="stats" className="tde-ml-0"/><span>{ this.getLoc("Variance") } (s&#x00B2;)</span></label></li>
                                        <li><label><input type="radio" value="kControlsMedian" checked={this.state.sampleStatistics==='kControlsMedian'} onChange={this.onSampleStatisticsChange}
                                                        name="stats" className="tde-ml-0"/><span>{ this.getLoc("Median") }</span></label></li>
                                        <li><label><input type="radio" value="kControlsInterQuartRange" checked={this.state.sampleStatistics==='kControlsInterQuartRange'} onChange={this.onSampleStatisticsChange}
                                                        name="stats" className="tde-ml-0"/><span>{ this.getLoc("Interquartile Range") }</span></label></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className='tde-divider-bottom'>
                        <div className={"tde-footer-btn-group tde-mb-4" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                            <button aria-label="Generate Sample Statistics" className="tde-btn tde-s1 tde-font-weight-bold tde-px-3 tde-mt-3" disabled={this.isGenerateButtonDisabled()} onClick={this.handleGenerate}>
                                { this.getLoc('Generate') }</button>
                            <PlainButton aria-label={this.getLoc('Close Sampling Card')} className="tde-pl-3 tde-s1" onClick={this.handleCancel}>{ this.getLoc('Cancel') }</PlainButton>

                        </div>
                    </div>
                    {hasSample && <div className="tde-row tde-pt-4 tde-divider-bottom tde-pb-4">
                        <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                            <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name tde-pb-1">
                                { this.getLoc('View') }<ToolTip tip={this.getLoc('Choose to view  the  population, sample, or distribution of sample statistics')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip>
                            </div>
                            <div className="tde-radiobox-section" /*onChange={this.onViewChange}*/>
                                <ul style={{listStyle: "none", margin: 0, padding: 0}}>
                                    <li>
                                        <label>
                                            <input type="radio" value="viewPopulation" checked={this.state.selectedView==='viewPopulation'} onChange={this.onViewChange}
                                                    name="activeView" className="tde-ml-0"/>
                                            <div className="tde-legend-color tde-mr-2" style={ styles.populationColor }></div>
                                            <span className="tde-s1 tde-font-weight-regular tde-attr-name">{ this.getLoc('Population') }</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="radio" value="viewSample" checked={this.state.selectedView==='viewSample'} onChange={this.onViewChange}
                                                    name="activeView" className="tde-ml-0"/>
                                            <div className="tde-legend-color tde-mr-2" style={ styles.sampleColor }></div>
                                            <span className="tde-s1 tde-font-weight-regular tde-attr-name">
                                                { this.getLoc('Sample' ) }
                                                <PlainButton
                                                className="tde-ml-2"
                                                aria-label={this.getLoc('View Previous Sample')}
                                                onClick={this.onNextPrevSample.bind(this, "prev")} >
                                                <i
                                                    className="tde-navigation-button tde-i tde-i-previous"
                                                    style={{ lineHeight: 1 }}>
                                                </i>
                                            </PlainButton>
                                            <span className="tde-s1 tde-no-wrap tde-ml-2">
                                                { this.state.selectedSampleIndex+1 }
                                            </span>
                                            <PlainButton
                                                className="tde-ml-2"
                                                aria-label={this.getLoc('View Next Sample')}
                                                onClick={this.onNextPrevSample.bind(this, "next")}>
                                                <i
                                                    className="tde-i tde-i-next"
                                                    style={{ lineHeight: 1 }}>
                                                </i>
                                            </PlainButton>
                                            </span>
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="radio" value="viewDistribution" checked={this.state.selectedView==='viewDistribution'} onChange={this.onViewChange}
                                                    name="activeView" className="tde-ml-0"/>
                                            <div className="tde-legend-color tde-mr-2" style={ styles.distributionColor }></div>
                                            <span className="tde-s1 tde-font-weight-regular tde-attr-name">{ this.getLoc('Distribution of Sample Statistics') }</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
}

export default RandomSampleComponent;
